import { render, staticRenderFns } from "./Speaking.vue?vue&type=template&id=31e94775&scoped=true&"
import script from "./Speaking.vue?vue&type=script&lang=js&"
export * from "./Speaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e94775",
  null
  
)

export default component.exports